/**
 * Styles for the plan-details Editors modal shell. The picker itself reuses EditorsSection.
 */
const editorsPlanModalStyles = () => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    boxSizing: 'border-box',
  },
});

export default editorsPlanModalStyles;

export const EditorsPlanModalStyles = () => ({
  '& .modal-footer div': {
    flexFlow: 'row-reverse',
    gap: 10,
  },
});
